import { useEffect, useRef, useState } from "react";
import { renderPoster, ensureFonts, getSize } from "@/lib/poster";

export const PosterCanvas = ({ cfg, photos, maxHeight, testId = "poster-canvas" }) => {
  const wrapRef = useRef(null);
  const canvasRef = useRef(null);
  const [box, setBox] = useState({ w: 0, h: 0 });
  const [fontsOk, setFontsOk] = useState(false);
  const size = getSize(cfg.sizeId);
  const ratio = size.w / size.h;

  useEffect(() => {
    ensureFonts().then(() => setFontsOk(true));
  }, []);

  useEffect(() => {
    const el = wrapRef.current;
    const ro = new ResizeObserver(([e]) => setBox({ w: e.contentRect.width, h: e.contentRect.height }));
    ro.observe(el);
    return () => ro.disconnect();
  }, []);

  const limitH = maxHeight || box.h || Infinity;
  const dispW = Math.max(0, Math.min(box.w, limitH * ratio));
  const dispH = dispW / ratio;

  useEffect(() => {
    const c = canvasRef.current;
    if (!c || !dispW) return;
    const dpr = Math.min(window.devicePixelRatio || 1, 2);
    c.width = Math.round(dispW * dpr);
    c.height = Math.round(dispH * dpr);
    renderPoster(c.getContext("2d"), c.width, c.height, cfg, photos);
  }, [cfg, photos, dispW, dispH, fontsOk]);

  return (
    <div ref={wrapRef} className="w-full h-full flex items-center justify-center">
      <div className="poster-frame" style={{ width: dispW, height: dispH }}>
        <canvas ref={canvasRef} data-testid={testId} style={{ width: dispW, height: dispH, display: "block" }} />
        <div className="canvas-texture" />
      </div>
    </div>
  );
};
